import React from "react";
import {
  Card,
  CardBody,
  Typography,
  Button
} from "@material-tailwind/react";
import { ArrowLongRightIcon, ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

export default function CiberCsirtcontent() {

 
  return (
    <>

      <div className="w-full mx-auto inline-block md:w-3/4 md:flex-row ">

 <nav
    className="w-11/12 mx-auto mt-6 mb-2 text-sm text-gray-500 lg:w-full"
    aria-label="Breadcrumb"
  >
    <Link
      to="/Servicios-Ciberseguridad"
      className="hover:text-indigo-600 transition font-medium"
    >
      Ciberseguridad
    </Link>
    <span className="mx-2">›</span>
    <span className="text-gray-800">
      Respuesta — CP-CSIRT
    </span>
  </nav>

  <div className="flex items-center gap-3 w-11/12 mx-auto mt-5 md:mt-0 lg:w-full mb-3">
                <ExclamationTriangleIcon className="text-indigo-500 w-10 h-10 group-hover:text-white" />
        <Typography
           variant="h3"
           className="text-black font-sanz text-left"
         >
           
          Respuesta — CP-CSIRT (Computer Security Incident Response Team)
        </Typography>
          </div>

        <Typography
          className="w-11/12 mx-auto md:mt-0 text-left lg:w-full font-mono text-xl"
        >Cuando ocurre un incidente real, activamos un equipo especializado para contener, analizar y resolver el evento de forma coordinada. Nuestro Equipo de Respuesta a Incidentes de Seguridad Informática (CSIRT) ejecuta análisis forense, apoya la gestión de crisis y define acciones inmediatas para restablecer la continuidad operativa en el menor tiempo posible.<br/>
        <br/>Posterior a cada incidente, generamos reportes con lecciones aprendidas que fortalecen tus controles y elevan la madurez de tu seguridad, convirtiendo cada experiencia en una oportunidad de mejora continua.
        </Typography>
        <div className="flex flex-wrap justify-center gap-3 mt-10 md:justify-around">
          
          <Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Plan de Respuesta a Incidentes
                </Typography>
                <Typography className="group-hover:text-white">
                 Diseño e implementación de un plan estructurado que permite responder a incidentes de seguridad de forma rápida, coordinada y efectiva.
                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Desarrollo de políticas y procedimientos
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Definición de roles y responsabilidades
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Establecimiento de flujos de comunicación
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Creación de playbooks de respuesta
  </li>
    <li className="flex items-start gap-2">
    <span>•</span> Simulacros y ejercicios de tabletop
  </li>
    <li className="flex items-start gap-2">
    <span>•</span> Actualización continua del plan
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>
          
                    <Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Implementación de CP-CSIRT
                </Typography>
                <Typography className="group-hover:text-white">
                 Configuración completa de un equipo de respuesta a incidentes, desde la planificación inicial hasta su operación efectiva dentro de la organización.
                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Diseño de la estructura del equipo
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Selección y entrenamiento de personal
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Implementación de herramientas especializadas
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Desarrollo de capacidades técnicas
  </li>
    <li className="flex items-start gap-2">
    <span>•</span>  Integración con procesos y sistemas existentes
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>
          
                              <Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Respuesta a Incidentes
                </Typography>
                <Typography className="group-hover:text-white">
                 Gestión integral de incidentes de seguridad con foco en contención, análisis, erradicación y recuperación operativa.
                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Investigación forense digital
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Contención de amenazas activas
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Erradicación de malware
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Recuperación de sistemas afectados
  </li>
    <li className="flex items-start gap-2">
    <span>•</span> Comunicación con áreas clave y stakeholders
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
                <button>
<Link to="/Contact/#form" className="inline-block ">
                                    <Button onClick={() => { localStorage.setItem("ESP", "CIB"); localStorage.setItem("SER", "RSP") }} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                                        Solicitar este servicio
                                        <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                                    </Button>
                                </Link>
                                </button>
         
          </div>
         
        </div>
      </div>
    </>
  );
}